import { registerFirestoreDocumentConverter } from "@/firestore/myFreeReads"
import { dexieFirestoreDocument } from "../../types/firestoreDocument"
import { Timestamp } from "firebase/firestore"
import { AttendanceEvent } from "./AttendanceEventType"

export const collectionName = "attendance_events"

export const dexieAttendanceEvent =
   dexieFirestoreDocument + ", type, young_id, school_year_id, [school_year_id+young_id], recurring_end_date, recurring_group"

export const init = () =>
   registerFirestoreDocumentConverter<AttendanceEvent>(collectionName, (data) => {
      const { from, to, recurring_end_date, ...rest } = data
      return {
         ...rest,
         from: (from as any as Timestamp)?.toDate(),
         to: (to as any as Timestamp)?.toDate(),
         recurring_end_date: (recurring_end_date as any as Timestamp)?.toDate(),
      }
   })
